import React, { useCallback, useMemo, useState } from 'react';
import { $TSFixMe } from 'src/interface';
import { useLanguage } from 'src/hooks';
import { GroupFilter } from 'src/components/general';
import { StickyTableConfig } from './stickyTable.interface';

type HookProps = {
  className?: string;
  modalClassName?: string;
  config: StickyTableConfig<$TSFixMe>[];
};

type HookResult = {
  stickyCols: Set<string>;
  stickyColsFilter: React.ReactNode;
  modalStickyColsFilter: React.ReactNode;
  applySCChanges: () => void;
  resetSCChanges: () => void;
};

export const useStickyCols = ({
  config,
  className,
  modalClassName,
}: HookProps): HookResult => {
  const [stickyCols, setStickyCols] = useState<Set<string>>(new Set());
  const [modalStickyCols, setModalStickyCols] = useState<Set<string>>(
    new Set(),
  );
  const { t } = useLanguage();

  const items = useMemo(
    () =>
      config.reduce(
        (result, { key, title, expandLabel }) => {
          if (expandLabel) {
            return result;
          }

          return [
            ...result,
            {
              id: key,
              label: title,
            },
          ];
        },
        [] as { id: string; label: string }[],
      ),
    [config],
  );

  return {
    stickyCols,
    stickyColsFilter: (
      <GroupFilter
        label={t('general.fixedCols')}
        selectedIDs={stickyCols}
        items={items}
        selectItem={(item, value) => {
          const updatedIDs = new Set(stickyCols);
          if (value) {
            updatedIDs.add(item);
          } else {
            updatedIDs.delete(item);
          }
          setStickyCols(updatedIDs);
          setModalStickyCols(updatedIDs);
        }}
        className={className}
      />
    ),
    modalStickyColsFilter: (
      <GroupFilter
        label={t('general.fixedCols')}
        selectedIDs={modalStickyCols}
        items={items}
        selectItem={(item, value) => {
          const updatedIDs = new Set(modalStickyCols);
          if (value) {
            updatedIDs.add(item);
          } else {
            updatedIDs.delete(item);
          }
          setModalStickyCols(updatedIDs);
        }}
        size="small"
        className={modalClassName}
      />
    ),
    applySCChanges: useCallback(() => {
      setStickyCols(modalStickyCols);
    }, [modalStickyCols]),
    resetSCChanges: useCallback(() => {
      setModalStickyCols(new Set());
    }, []),
  };
};
